export default __webpack_public_path__ + "static/media/hi.1ce3fe73.jpg";